import EmbedWidget from '@/components/EmbedWidget';

export default function WidgetPage() {
  return (
    <div className="min-h-screen bg-transparent">
      <EmbedWidget />
    </div>
  );
}
